import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemStr, sessionGetItemObj } from '../../../utils/sessionHelpers'
import { useHistory } from 'react-router-dom'
import pathname from '../../../constants/pathname'
import SubProjectVoucherListWidget from '../../../widgets/projectBasedItemsWidget/SubProjectVoucherListWidget'
import { getSubprojectIncomExpensesList } from '../../../redux/actions/accountingSubProject'

export default function SubProjectVoucherList() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionGetItemStr('subProjectCode')
  const periodNumber = sessionGetItemStr('subProjectPeriod')
  const { periodNo, startAndEndDate, periodOfLength } = sessionGetItemObj('periodInfo')
  const param = sessionGetItemObj('param')
  const history = useHistory()

  useEffect(() => {
    handleGetSchema()

    if (!param) {
      history.push({
        pathname: pathname.incomeAndExpense.SubProjectProjectBasedItems,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSubprojectIncomExpensesList(projectCode, periodNumber || periodNo)
      // console.log('getPeriodicManagement 1234 ', _schema.model)
      setSchema(_schema.model)
      // setSchema(mockSchema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isIncomeAndExpense>
      <ContentHeader
        header={schema?.header || 'รายละเอียดการบันทึก รับ-จ่าย โครงการย่อย'}
        subHeader={''}
        isNotCallApi
        isShowGoButton
      />

      <SubProjectVoucherListWidget
        schema={schema}
        periodNumber={periodNumber}
        projectCode={projectCode}
      />

      <br />
    </SidebarProposal>
  )
}

// const mockSchema = {
//   affectedRows: 0,
//   message: null,
//   didError: false,
//   errorMessage: null,
//   model: {
//     header: 'รายละเอียดการบันทึก รับ-จ่าย โครงการย่อย',
//     recordType: {
//       label: 'ประเภทรายการ',
//       name: 'recordType',
//       value: null,
//       disabled: false,
//       options: [
//         {
//           disabled: false,
//           label: 'ทั้งหมด',
//           value: '0',
//         },
//         {
//           disabled: false,
//           label: 'รายการรับ',
//           value: '1',
//         },
//         {
//           disabled: false,
//           label: 'รายการจ่าย',
//           value: '2',
//         },
//       ],
//       validators: null,
//     },
//     voucherNumber: {
//       name: 'voucherNumber',
//       label: 'เลขที่ใบสำคัญ',
//     },
//     activityCode: {
//       name: 'activityCode',
//       label: 'รหัสกิจกรรมรายการ',
//     },
//     description: {
//       name: 'description',
//       label: 'คำอธิบายรายการ',
//     },
//     values: [
//       {
//         id: '12345',
//         documentDate: '1 ม.ค. 2565',
//         voucherNumber: 'PP-66-10001',
//         description: 'เงินรับจาก สสส. งวดที่ 1 ',
//         amount: '100,000.00',
//         type: 'Income',
//         warning: '',
//         warningColor: '',
//       },
//       {
//         id: '123456',
//         documentDate: '2 ม.ค. 2565',
//         voucherNumber: 'PP-66-10001',
//         description: 'รับเงินยืมเพื่อเปิดบัญชี',
//         amount: '500.00',
//         type: 'Income',
//         warning: '',
//         warningColor: '',
//       },
//       {
//         id: '12347',
//         documentDate: '2 ม.ค. 2565',
//         voucherNumber: 'PP-66-10001',
//         description: 'จ่ายเงินเดือนเจ้าหน้าที่ มค. 66',
//         amount: '78000.00',
//         type: 'Expense',
//         warning: '',
//         warningColor: '',
//       },
//       {
//         id: '12348',
//         documentDate: '2 ม.ค. 2565',
//         voucherNumber: 'PP-66-10001',
//         description: 'คอมพิวเตอร์ใช้งาน',
//         amount: '25000.00',
//         type: 'Expense',
//         warning: 'ยังไม่ขึ้นทะเบียนครุภัณฑ์',
//         warningColor: '#fb8a81',
//       },
//     ],
//   },
// }
